import { Checkbox } from '../../ui/checkbox';
import { Label } from '../../ui/label';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import { Badge } from '../../ui/badge';
import { ScrollArea } from '../../ui/scroll-area';
import { Layers, FileText } from 'lucide-react';

const ItemMeta = ({ item }) => (
  <span className="ml-auto flex items-center gap-1.5 shrink-0">
    {item.content_count > 0 && <Badge variant="outline" className="text-[10px]">{item.content_count} content</Badge>}
    {item.has_assessment && <Badge variant="outline" className="text-[10px] border-amber-300 text-amber-600">Quiz</Badge>}
  </span>
);

const ResetScopeSelector = ({ modules, scope, onScopeChange, selectedModules, selectedSubs, onToggleModule, onToggleSub }) => (
  <div className="space-y-3" data-testid="reset-scope-selector">
    <Label className="text-sm font-medium">What to reset</Label>
    <RadioGroup value={scope} onValueChange={onScopeChange} className="flex flex-wrap gap-4">
      <div className="flex items-center gap-2">
        <RadioGroupItem value="course" id="reset-scope-course" data-testid="reset-scope-course" />
        <Label htmlFor="reset-scope-course" className="font-normal cursor-pointer">Entire course</Label>
      </div>
      <div className="flex items-center gap-2">
        <RadioGroupItem value="items" id="reset-scope-items" data-testid="reset-scope-items" disabled={!modules.length} />
        <Label htmlFor="reset-scope-items" className="font-normal cursor-pointer">Specific modules / sub-modules</Label>
      </div>
    </RadioGroup>

    {scope === 'items' && (
      <ScrollArea className="h-[240px] rounded-md border p-3">
        <div className="space-y-2">
          {modules.map(module => {
            const moduleChecked = selectedModules.has(module.id);
            return (
              <div key={module.id} className="space-y-1.5">
                <label className="flex items-center gap-2 text-sm cursor-pointer">
                  <Checkbox
                    checked={moduleChecked}
                    onCheckedChange={() => onToggleModule(module)}
                    data-testid={`reset-module-checkbox-${module.id}`}
                  />
                  <Layers className="h-4 w-4 text-muted-foreground" />
                  <span className="font-medium truncate">{module.title}</span>
                  <ItemMeta item={module} />
                </label>
                {module.sub_modules.map(sm => (
                  <label key={sm.id} className="flex items-center gap-2 text-sm pl-7 cursor-pointer">
                    <Checkbox
                      checked={moduleChecked || selectedSubs.has(sm.id)}
                      disabled={moduleChecked}
                      onCheckedChange={() => onToggleSub(sm.id)}
                      data-testid={`reset-submodule-checkbox-${sm.id}`}
                    />
                    <FileText className="h-3.5 w-3.5 text-muted-foreground" />
                    <span className="truncate">{sm.title}</span>
                    <ItemMeta item={sm} />
                  </label>
                ))}
              </div>
            );
          })}
        </div>
      </ScrollArea>
    )}
  </div>
);

export default ResetScopeSelector;
